import { BreadcrumbWrapperReimagine } from '../../components/common/breadcrumb-wrapper-reimagine/breadcrumb-wrapper-reimagine';
import { ViewTemplate } from '../../components/sections';
import React from 'react';
import { useVehicleHealthPageComponents } from '../../components/sections/vehicle-health/components/vehicle-health-page-components';
import { SlowTireLeakDetails } from '../../components/sections/vehicle-health/components/slow-tire-leak/slow-tire-leak-details';
import { useSlowTireLeakDetailsContent } from '../../components/sections/vehicle-health/hook/use-slow-tire-leak-details-content';
import serverSideService from '../../services/server-side-service/server-side-service';
export const SlowTireLeakDetailsView = () => {
    const slowTireLeakDetailsContent: any = useSlowTireLeakDetailsContent();
    const [vehicleHealthComponent] = useVehicleHealthPageComponents();
    const VhaAlertBreadCrumb = () => {
        let vhaUrl = '';
        if (serverSideService.isClientSide()) {
            const currentRoute = window.location.pathname;
            vhaUrl = currentRoute.endsWith('/')
                ? currentRoute.substring(0, currentRoute.length - 1)
                : currentRoute;
        }

        const handleClick = () => {
            window.location.href = `${vhaUrl.substr(
                0,
                vhaUrl.lastIndexOf('/')
            )}`;
        };
        return (
            <>
                <span
                    className="breadcrumb-link-ellipses-expanded"
                    onClick={handleClick}
                >
                    <span>{vehicleHealthComponent?.vehicleHealthTitle}</span>
                </span>
                <span className="back-slash">{'/'}</span>
            </>
        );
    };
    return (
        <>
            {slowTireLeakDetailsContent && (
                <ViewTemplate
                    page={
                        slowTireLeakDetailsContent?.slowTireLeak
                            ?.slowTireLeakBreadcrum
                    }
                >
                    <BreadcrumbWrapperReimagine
                        currentPage={
                            slowTireLeakDetailsContent?.slowTireLeak
                                .slowTireLeakBreadcrum
                        }
                        hashId="support"
                        title={<VhaAlertBreadCrumb />}
                    />
                    <SlowTireLeakDetails />
                </ViewTemplate>
            )}
        </>
    );
};

export default SlowTireLeakDetailsView;
